import { render, staticRenderFns } from "./ServizioPeriodicoDetail.vue?vue&type=template&id=c5d13542&"
import script from "./ServizioPeriodicoDetail.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports